import { combineReducers } from 'redux';
import {
  LIBRARY_ITEM_SET_ITEM_LIST,
  LIBRARY_ITEM_SET_CATEGORY_LIST,
  LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID,
  LIBRARY_ITEM_SET_CURRENT_ITEM_ID,
  LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID,
  LIBRARY_ITEM_SET_OUTLETS,
  LIBRARY_ITEM_SET_ITEM_SUMMARY,
  LIBRARY_ITEM_SET_FILTER_STATE,
  LIBRARY_ITEM_SET_TOTAL_PAGE,
  LIBRARY_ITEM_SET_CURRENT_PAGE,
  LIBRARY_ITEM_UNSET_FILTER_STATE,
  LIBRARY_ITEM_SET_TYPE_IMPORT,
  LIBRARY_ITEM_SHOW_SECTION_UPLOADER,
  LIBRARY_ITEM_OPEN_RIGHT_COLUMN,
  LIBRARY_ITEM_CLOSE_RIGHT_COLUMN,
  LIBRARY_ITEM_SET_ITEM_DETAIL,
  LIBRARY_ITEM_ON_DROP_IMAGE,
  LIBRARY_ITEM_ON_DELETE_IMAGE,
  LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL,
  LIBRARY_ITEM_SHOW_SALES_TYPE_MODAL,
  LIBRARY_ITEM_HIDE_SALES_TYPE_MODAL,
  LIBRARY_ITEM_SHOW_COGS_MODAL,
  LIBRARY_ITEM_HIDE_COGS_MODAL,
  LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM,
  LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL,
  LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL,
  LIBRARY_ITEM_SET_MODIFIERS,
  LIBRARY_ITEM_HIDE_DELETE_MODAL,
  LIBRARY_ITEM_SHOW_DELETE_MODAL,
  LIBRARY_ITEM_HIDE_UPDATE_MODAL,
  LIBRARY_ITEM_SHOW_UPDATE_MODAL,
  LIBRARY_ITEM_SET_NEW_CATEGORY,
  LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL,
  LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL,
  LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID,
  LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES,
  LIBRARY_ITEM_SHOW_IMPORT_MODAL,
  LIBRARY_ITEM_HIDE_IMPORT_MODAL,
  LIBRARY_ITEM_SET_MUST_SCROLL_TOP,
  LIBRARY_ITEM_SET_IS_SUBMITTING_FORM,
  LIBRARY_ITEM_SET_REWARD_ITEM_LIST,
  LIBRARY_ITEM_SET_REWARD_CATEGORY_LIST,
  LIBRARY_ITEM_SET_REWARD_ITEM_VARIANT_OF,
  LIBRARY_ITEM_SET_POINT_GAIN_ITEM_LIST,
  LIBRARY_ITEM_SET_POINT_GAIN_CATEGORY_LIST,
  LIBRARY_ITEM_SET_POINT_GAIN_ITEM_VARIANT_OF,
  LIBRARY_ITEM_SET_VALIDATION_MODAL,
  LIBRARY_ITEM_SET_VALIDATION_MODAL_MESSAGE,
  LIBRARY_ITEM_ITEM_LIST_EXPORT_START,
  LIBRARY_ITEM_ITEM_LIST_EXPORT_FINISHED,
  LIBRARY_ITEM_ITEM_LIST_EXPORT_ERROR,
  LIBRARY_ITEM_SET_BRAND_LIST,
  LIBRARY_ITEM_SET_NEW_BRAND,
  LIBRARY_ITEM_SET_PREVIOUS_BRAND,
  LIBRARY_ITEM_SET_PREVIOUS_BRAND_ID,
  LIBRARY_ITEM_CREATE_BRAND_SHOW_MODAL,
  LIBRARY_ITEM_CREATE_BRAND_HIDE_MODAL,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA_NO_SAGA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_INPUT,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA_NO_SAGA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_INPUT,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA_NO_SAGA,
  LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_INPUT,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA,
  LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY,
  LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY_FASHION,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA_NO_SAGA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA_NO_SAGA,
  LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA_NO_SAGA,
  LIBRARY_ITEM_SET_ITEM_IS_RETAIL,
  LIBRARY_ITEM_SHOW_UPDATE_ALL_OUTLET_MODAL,
  LIBRARY_ITEM_HIDE_UPDATE_ALL_OUTLET_MODAL,
  LIBRARY_ITEM_SHOW_ERROR_UPDATE_ALL_OUTLET_MODAL,
  LIBRARY_ITEM_HIDE_ERROR_UPDATE_ALL_OUTLET_MODAL,
} from 'actions/library/item/constants';
import createReducer from 'utils/createReducer';

const categories = createReducer([], {
  [LIBRARY_ITEM_SET_CATEGORY_LIST]: (draft, { payload }) => payload.categories,
});

const currentCategoryId = createReducer(0, {
  [LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID]: (draft, { payload }) =>
    payload.categoryId,
});

const currentInventoryId = createReducer(0, {
  [LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID]: (draft, { payload }) =>
    payload.inventoryId,
});

const currentItemId = createReducer(0, {
  [LIBRARY_ITEM_SET_CURRENT_ITEM_ID]: (draft, { payload }) =>
    payload.currentItemId,
});

const currentPage = createReducer(null, {
  [LIBRARY_ITEM_SET_CURRENT_PAGE]: (draft, { payload }) => payload.currentPage,
});

const deletedItem = createReducer(null, {});

const files = createReducer(null, {
  [LIBRARY_ITEM_ON_DROP_IMAGE]: (draft, { payload }) =>
    payload.fileStateacceptedFiles,

  [LIBRARY_ITEM_ON_DELETE_IMAGE]: (draft, { payload }) =>
    payload.fileStateacceptedFiles,
});

const filterState = createReducer(
  { categoryId: 0, outletId: 0, typeInventoryId: 0, keyword: '' },
  {
    [LIBRARY_ITEM_SET_FILTER_STATE]: (draft, { payload }) => ({
      categoryId: payload.categoryId,
      outletId: payload.outletId,
      typeInventoryId: payload.typeInventoryId,
      keyword: payload.keyword,
    }),

    [LIBRARY_ITEM_UNSET_FILTER_STATE]: () => ({
      categoryId: 0,
      outletId: 0,
      typeInventoryId: 0,
      keyword: '',
    }),
  }
);

const gravatar = createReducer(null, {
  [LIBRARY_ITEM_ON_DELETE_IMAGE]: (draft, { payload }) =>
    payload.fileStategravatar,
});

const importType = createReducer('modify', {
  [LIBRARY_ITEM_SET_TYPE_IMPORT]: (draft, { payload }) => payload.importType,
});

const inventories = createReducer(
  [
    { id: '0', name: 'All Inventory' },
    { id: '1', name: 'Low Stock Alert' },
    { id: '2', name: 'Out of Stock Alert' },
  ],
  {}
);

const customCategoriesEcommerceFashion = createReducer([], {
  [LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY_FASHION]: (_, { payload }) =>
    payload,
});

const setCustomCategoryInputFunc = (draft, payload, type) => {
  return {
    ...draft,
    [type]: {
      ...draft[type],
      input: payload.split(',')[0].substr(0, 20),
    },
  };
};

const setCustomCategoryDataFunc = (draft, payload, type) => {
  const isFound = draft[type].data.find(val => val === payload);
  if (!isFound) {
    return {
      ...draft,
      [type]: {
        input: '',
        data: [...draft[type].data, payload],
      },
    };
  }
};

const unsetCustomCategoryDataFunc = (draft, payload, type) => ({
  ...draft,
  [type]: {
    ...draft[type],
    data: draft[type].data.filter((_, i) => i !== payload),
  },
});

const unsetCustomCategoryAllDataFunc = (draft, type) => ({
  ...draft,
  [type]: {
    ...draft[type],
    data: [],
  },
});

const unsetCustomCategoryAllDataNoSagaFunc = (draft, type) => ({
  ...draft,
  [type]: {
    input: '',
    data: [],
  },
});

const customCategoriesEcommerceFashionData = createReducer(
  {
    colors: {
      input: '',
      data: [],
    },
    sizes: {
      input: '',
      data: [],
    },
    materials: {
      input: '',
      data: [],
    },
  },
  {
    [LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_INPUT]: (
      draft,
      { payload }
    ) => setCustomCategoryInputFunc(draft, payload, 'colors'),
    [LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA]: (
      draft,
      { payload }
    ) => setCustomCategoryDataFunc(draft, payload, 'colors'),
    [LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA_NO_SAGA]: (
      draft,
      { payload }
    ) => setCustomCategoryDataFunc(draft, payload, 'colors'),
    [LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_DATA]: (
      draft,
      { payload }
    ) => unsetCustomCategoryDataFunc(draft, payload, 'colors'),
    [LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA]: draft =>
      unsetCustomCategoryAllDataFunc(draft, 'colors'),
    [LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA_NO_SAGA]: draft =>
      unsetCustomCategoryAllDataNoSagaFunc(draft, 'colors'),
    [LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_INPUT]: (
      draft,
      { payload }
    ) => setCustomCategoryInputFunc(draft, payload, 'sizes'),
    [LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA_NO_SAGA]: (
      draft,
      { payload }
    ) => setCustomCategoryDataFunc(draft, payload, 'sizes'),
    [LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA]: (
      draft,
      { payload }
    ) => setCustomCategoryDataFunc(draft, payload, 'sizes'),
    [LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_DATA]: (
      draft,
      { payload }
    ) => unsetCustomCategoryDataFunc(draft, payload, 'sizes'),
    [LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA]: draft =>
      unsetCustomCategoryAllDataFunc(draft, 'sizes'),
    [LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA_NO_SAGA]: draft =>
      unsetCustomCategoryAllDataNoSagaFunc(draft, 'sizes'),
    [LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_INPUT]: (
      draft,
      { payload }
    ) => setCustomCategoryInputFunc(draft, payload, 'materials'),
    [LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA_NO_SAGA]: (
      draft,
      { payload }
    ) => setCustomCategoryDataFunc(draft, payload, 'materials'),
    [LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA]: (
      draft,
      { payload }
    ) => setCustomCategoryDataFunc(draft, payload, 'materials'),
    [LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA]: (
      draft,
      { payload }
    ) => unsetCustomCategoryDataFunc(draft, payload, 'materials'),
    [LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA]: draft =>
      unsetCustomCategoryAllDataFunc(draft, 'materials'),
    [LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA_NO_SAGA]: draft =>
      unsetCustomCategoryAllDataNoSagaFunc(draft, 'materials'),
  }
);

const isSubmittingForm = createReducer(false, {
  [LIBRARY_ITEM_SET_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const isTrack = createReducer(false, {
  [LIBRARY_ITEM_SHOW_COGS_MODAL]: (draft, { payload }) => payload.isTrack,
});

const itemDetail = createReducer(null, {
  [LIBRARY_ITEM_SET_ITEM_DETAIL]: (draft, { payload }) => payload.item,
});

const itemExportState = createReducer(
  {
    exporting: false,
    asyncJobId: null,
    asyncJobCreated: false,
    pusherChannel: null,
    pusherEvent: null,
  },
  {
    [LIBRARY_ITEM_ITEM_LIST_EXPORT_START]: (draft, { payload }) => ({
      exporting: true,
      asyncJobId: payload.asyncJobId,
      asyncJobCreated: payload.asyncJobCreated,
      pusherChannel: payload.pusherChannel,
      pusherEvent: payload.pusherEvent,
    }),

    [LIBRARY_ITEM_ITEM_LIST_EXPORT_FINISHED]: () => ({
      exporting: false,
      asyncJobId: null,
      asyncJobCreated: false,
      pusherChannel: null,
      pusherEvent: null,
    }),

    [LIBRARY_ITEM_ITEM_LIST_EXPORT_ERROR]: () => ({
      exporting: false,
      asyncJobId: null,
      asyncJobCreated: false,
      pusherChannel: null,
      pusherEvent: null,
    }),
  }
);

const items = createReducer([], {
  [LIBRARY_ITEM_SET_ITEM_LIST]: (draft, { payload }) => payload.items,
});

const ecommerceCategory = createReducer(
  {},
  {
    [LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY]: (_, { payload }) => payload,
  }
);

const modifierIds = createReducer([], {});

const modifiers = createReducer([], {
  [LIBRARY_ITEM_SET_MODIFIERS]: (draft, { payload }) => payload.modifiers,
});

const mustScrollTop = createReducer(false, {
  [LIBRARY_ITEM_SET_MUST_SCROLL_TOP]: (draft, { payload }) =>
    payload.mustScrollTop,
});

const newCategory = createReducer(null, {
  [LIBRARY_ITEM_SET_NEW_CATEGORY]: (draft, { payload }) => payload.category,
});

const openRightColumn = createReducer(false, {
  [LIBRARY_ITEM_OPEN_RIGHT_COLUMN]: () => true,
  [LIBRARY_ITEM_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  [LIBRARY_ITEM_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const pointGainCategoryList = createReducer([], {
  [LIBRARY_ITEM_SET_POINT_GAIN_CATEGORY_LIST]: (draft, { payload }) =>
    payload.categories,
});

const pointGainItemList = createReducer([], {
  [LIBRARY_ITEM_SET_POINT_GAIN_ITEM_LIST]: (draft, { payload }) =>
    payload.items,
});

const pointGainItemVariantOf = createReducer([], {
  [LIBRARY_ITEM_SET_POINT_GAIN_ITEM_VARIANT_OF]: (draft, { payload }) =>
    payload.itemVariants,
});

const previousCategories = createReducer([], {
  [LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES]: (draft, { payload }) =>
    payload.categories,
});

const previousCategoryId = createReducer(null, {
  [LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID]: (draft, { payload }) =>
    payload.categoryId,
});

const previousItemForm = createReducer(
  {
    name: null,
    category: null,
    itemVariant: [],
    itemInventory: [],
    itemModifier: [],
    description: null,
  },
  {
    [LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM]: (draft, { payload }) => ({
      ...payload.previousItemForm,
    }),
  }
);

const removeImage = createReducer(false, {
  [LIBRARY_ITEM_ON_DROP_IMAGE]: (draft, { payload }) =>
    payload.fileStateremoveImage,

  [LIBRARY_ITEM_ON_DELETE_IMAGE]: (draft, { payload }) =>
    payload.fileStateremoveImage,
});

const rewardCategoryList = createReducer([], {
  [LIBRARY_ITEM_SET_REWARD_CATEGORY_LIST]: (draft, { payload }) =>
    payload.categories,
});

const rewardItemList = createReducer([], {
  [LIBRARY_ITEM_SET_REWARD_ITEM_LIST]: (draft, { payload }) => payload.items,
});

const rewardItemVariantOf = createReducer(
  {},
  {
    [LIBRARY_ITEM_SET_REWARD_ITEM_VARIANT_OF]: (draft, { payload }) =>
      payload.itemVariants,
  }
);

const search = createReducer('', {});

const showCOGSModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_COGS_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_COGS_MODAL]: () => false,
});

const showDeleteItemModal = createReducer(false, {});

const showDeleteModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_DELETE_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_DELETE_MODAL]: () => false,
});

const showImportModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_IMPORT_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_IMPORT_MODAL]: () => false,
});

const showItemInventoryAlertModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL]: () => false,
});

const showItemVariantModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL]: () => false,
});

const showNewCategoryModal = createReducer(false, {
  [LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL]: () => true,
  [LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL]: () => false,
});

const showSalesTypeModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_SALES_TYPE_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_SALES_TYPE_MODAL]: () => false,
});

const showSaveToAllOutletsModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL]: () => false,
});

const showSectionUploader = createReducer(false, {
  [LIBRARY_ITEM_SHOW_SECTION_UPLOADER]: (draft, { payload }) =>
    payload.showSectionUploader,
});

const showUpdateModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_UPDATE_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_UPDATE_MODAL]: () => false,
});

const showUploadValidationModal = createReducer(false, {});

const showValidateSaveToAllWarningModal = createReducer(false, {
  [LIBRARY_ITEM_SET_VALIDATION_MODAL]: (draft, { payload }) => payload.isOpen,
});

const summary = createReducer(
  { total_pages: 0, total_items: 0 },
  {
    [LIBRARY_ITEM_SET_ITEM_SUMMARY]: (draft, { payload }) =>
      payload.itemSummary,
  }
);

const tempFiles = createReducer({}, {});
const textModal = createReducer('', {});

const totalPage = createReducer(null, {
  [LIBRARY_ITEM_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

const validationModalMessage = createReducer(0, {
  [LIBRARY_ITEM_SET_VALIDATION_MODAL_MESSAGE]: (draft, { payload }) =>
    payload.message,
});

const brands = createReducer([], {
  [LIBRARY_ITEM_SET_BRAND_LIST]: (_, { payload }) => payload.brands,
});

const newBrand = createReducer(null, {
  [LIBRARY_ITEM_SET_NEW_BRAND]: (draft, { payload }) => payload.brand,
});

const previousBrand = createReducer([], {
  [LIBRARY_ITEM_SET_PREVIOUS_BRAND]: (draft, { payload }) => payload.brand,
});

const previousBrandId = createReducer(null, {
  [LIBRARY_ITEM_SET_PREVIOUS_BRAND_ID]: (draft, { payload }) => payload.brandId,
});

const showNewBrandModal = createReducer(false, {
  [LIBRARY_ITEM_CREATE_BRAND_SHOW_MODAL]: () => true,
  [LIBRARY_ITEM_CREATE_BRAND_HIDE_MODAL]: () => false,
});

const isRetail = createReducer(false, {
  [LIBRARY_ITEM_SET_ITEM_IS_RETAIL]: (_, { payload }) => payload.isRetail,
});

const showUpdateToAllOutletsModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_UPDATE_ALL_OUTLET_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_UPDATE_ALL_OUTLET_MODAL]: () => false,
});

const showErrorUpdateAllOutletModal = createReducer(false, {
  [LIBRARY_ITEM_SHOW_ERROR_UPDATE_ALL_OUTLET_MODAL]: () => true,
  [LIBRARY_ITEM_HIDE_ERROR_UPDATE_ALL_OUTLET_MODAL]: () => false,
});

export default combineReducers({
  brands,
  categories,
  currentCategoryId,
  currentInventoryId,
  currentItemId,
  currentPage,
  customCategoriesEcommerceFashion,
  customCategoriesEcommerceFashionData,
  deletedItem,
  files,
  filterState,
  gravatar,
  importType,
  inventories,
  isSubmittingForm,
  isTrack,
  isRetail,
  itemDetail,
  itemExportState,
  items,
  ecommerceCategory,
  modifierIds,
  modifiers,
  mustScrollTop,
  newBrand,
  newCategory,
  openRightColumn,
  outlets,
  pointGainCategoryList,
  pointGainItemList,
  pointGainItemVariantOf,
  previousBrand,
  previousBrandId,
  previousCategories,
  previousCategoryId,
  previousItemForm,
  removeImage,
  rewardCategoryList,
  rewardItemList,
  rewardItemVariantOf,
  search,
  showCOGSModal,
  showDeleteItemModal,
  showDeleteModal,
  showImportModal,
  showItemInventoryAlertModal,
  showItemVariantModal,
  showNewBrandModal,
  showNewCategoryModal,
  showSalesTypeModal,
  showSaveToAllOutletsModal,
  showSectionUploader,
  showUpdateModal,
  showUploadValidationModal,
  showValidateSaveToAllWarningModal,
  summary,
  tempFiles,
  textModal,
  totalPage,
  validationModalMessage,
  showUpdateToAllOutletsModal,
  showErrorUpdateAllOutletModal,
});
